export enum vendorName {
    ms = 'meinestadt.de GmbH',
}
